import { useQuery } from '@tanstack/react-query';
import { piAccessService } from '../services/piaccess.service';
import { useFirebaseAuth } from '../contexts/FirebaseAuthContext';

export const usePiAccessStatus = () => {
  const { user, loading } = useFirebaseAuth();

  return useQuery({
    queryKey: ['piaccess', 'status'],
    queryFn: async () => {
      try {
        return await piAccessService.getStatus();
      } catch (error: any) {
        // If unauthorized, return default no-access state
        if (error?.status === 401 || error?.statusCode === 401) {
          return { hasAccess: false, piAccess: null };
        }
        throw error;
      }
    },
    // Only run query when Firebase auth is initialized and user is signed in
    enabled: !loading && !!user,
    retry: false,
  });
};

export const usePiAccessConfig = () => {
  return useQuery({
    queryKey: ['piaccess', 'config'],
    queryFn: () => piAccessService.getPricingConfig(),
    staleTime: 1000 * 60 * 5,
    retry: false,
  });
};
